import { endpoints } from "configs";
import { request } from "utils";
import { notification } from "components";
import { HandleSubmit } from "./types";

export const handleSubmit: HandleSubmit = ({ t, values }) => {
  const userRoleValue =
    values.email && values.email.includes("@acceleratelearning.com")
      ? "ali_staff"
      : "client_staff";

  const data = {
    feedback: {
      type: values.reason,
      email: values.email,
      name: values.name,
      comments: values.comments,
      contextUrl: window.location.href,
      userRole: userRoleValue,
      loadedFiles: values.loadedFiles,
      suggestionList: {
        featureAvailable: values.featureAvailable || "",
        isThisDigital: values.isThisDigital || "",
        primaryValueThisFeature: values.primaryValueThisFeature || "",
        thisFunctionalityInOurCompetitors:
          values.thisFunctionalityInOurCompetitors || "",
        ifThisSuggestionIsImplemented:
          values.ifThisSuggestionIsImplemented || "",
      },
    },
  };

  return request.post(endpoints.feedbackCreate, data).then(() => {
    notification.createSuccess({ content: t("feedback.success") as string });
  });
};
